"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var katal_metrics_1 = require("@amzn/katal-metrics");
var KATAL_MONITORING_DIMENSION = { 'Katal Product': 'Katal Weblab' };
var CacheRefresher = /** @class */ (function () {
    function CacheRefresher(treatmentCache, cacheSettings, client, errorHandler, publisher, monitor) {
        this.treatmentCache = treatmentCache;
        this.cacheSettings = cacheSettings;
        this.client = client;
        this.errorHandler = errorHandler;
        this.publisher = publisher;
        this.monitor = monitor;
    }
    /**
     * Kicks off refreshing the cached treatments in the background
     */
    CacheRefresher.prototype.run = function () {
        var _this = this;
        var METRIC_NAME = 'GetTreatments';
        var intervalInMillis = this.cacheSettings.cacheRefreshRateSeconds * 1000;
        setInterval(function () {
            var _a;
            var weblabs = _this.treatmentCache.getCachedWeblabs();
            if (!weblabs.length) {
                return;
            }
            var metricAttempt = new katal_metrics_1.Metric.TimedAttempt(METRIC_NAME).withMonitor();
            var monitorAttempt = (_a = _this.monitor) === null || _a === void 0 ? void 0 : _a.recordStatMetrics(METRIC_NAME, KATAL_MONITORING_DIMENSION);
            _this.client
                .getTreatments(weblabs)
                .then(function (results) {
                var _a;
                metricAttempt.setSuccess();
                _this.publishMetricsIfExists(function (publisher) {
                    publisher.publish(metricAttempt);
                });
                (_a = monitorAttempt) === null || _a === void 0 ? void 0 : _a.success();
                var changes = [];
                results.forEach(function (treatment, weblab) {
                    var current = _this.treatmentCache.getTreatment(weblab.id);
                    if (!current ||
                        current.treatmentValue !== treatment.treatmentValue) {
                        _this.treatmentCache.addTreatment(treatment, weblab);
                        changes.push(treatment);
                    }
                });
                if (_this.cacheSettings.cacheListener && changes.length > 0) {
                    _this.cacheSettings.cacheListener(changes);
                }
            })
                .catch(function (error) {
                var _a;
                //In the event the weblab service throws an error we do not want to update the cache
                //It will just retry in the next interval
                metricAttempt.setFailure();
                _this.publishMetricsIfExists(function (publisher) {
                    publisher.publish(metricAttempt);
                });
                (_a = monitorAttempt) === null || _a === void 0 ? void 0 : _a.fault();
                _this.errorHandler(error);
            });
        }, intervalInMillis);
    };
    CacheRefresher.prototype.publishMetricsIfExists = function (callback) {
        if (this.publisher) {
            callback(this.publisher);
        }
    };
    return CacheRefresher;
}());
exports.CacheRefresher = CacheRefresher;
